// import './AddAllExpensesForm.css'
// import CustomInput from "../CustomInput/CustomInput";
// import CustomBtn from "../CustomBtn/CustomBtn";
// import { useEffect, useState } from 'react';
// import { Col, Container, Row } from 'react-bootstrap';
// import "react-toastify/dist/ReactToastify.css";
// import Select from 'react-select';
// import { useSelector } from 'react-redux';
// import { toast, ToastContainer } from 'react-toastify';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';

// function AddAllExpensesForm() {
//   const userinfo = useSelector((state) => state);
//   const { currentLocal } = useSelector((state) => state.currentLocal);
//   const navigate = useNavigate();
//   const { id } = useParams()

//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [grade_id, setGrade_id] = useState("");
//   const [stage_id, setStages_id] = useState("");

//   const [price, setPrice] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [gradeItems, setGradeItems] = useState([])
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [stagesItems, setstageItems] = useState([])
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [email, setEmail] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [password, setPssword] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [Tuitionfees, setTuitionfees] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [Transportationfees, setTransportationfees] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [Mealfees, setMealfees] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [Bookfees, setBookfees] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [Studyexpenses, setStudyexpenses] = useState('')
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [Distancetravelfees, setDistancetravelfees] = useState('')

//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const [loading, setLoading] = useState('')
//   const [details, setDetails] = useState([
//     { name: "مقدم الدفع", price: 0 },
//     { name: "المبلغ الذي بدفع أول يوم دراسة", price: 0 },
//     { name: "سبتمبر", price: 0 },
//     { name: "أكتوبر", price: 0 },
//     { name: "نوفمبر", price: 0 },
//     { name: "ديسمبر", price: 0 },
//     { name: "يناير", price: 0 },
//     { name: "فبراير", price: 0 },
//     { name: "مارس", price: 0 },
//     { name: "أبريل", price: 0 },
//     { name: "مايو", price: 0 },
//   ]);

//   useEffect(() => {
//     const getAllApis = async () => {
// try {
//             await axios
//                 .get(`https://nanosoft.space/taarteb/public/api/admin/expenses`, {
//                     headers: {
//                         Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
//                     }
//                 })
//                 .then(async (res) => {
//                   console.log(res?.data?.data);
//                   const filterData=res.data.data.find((item)=>item?.id==id)
// console.log(filterData);
// setGrade_id({label:filterData?.grade_category?.name,value:filterData?.grade_category?.id})
// setStages_id({label:filterData?.grade?.name,value:filterData?.grade?.id})
// setPrice(filterData?.price)
// setBookfees(filterData?.installments[4]?.price)
// setMealfees(filterData?.installments[2]?.price)
// setTransportationfees(filterData?.installments[1]?.price)
// setTuitionfees(filterData?.installments[0]?.price)
// setStudyexpenses(filterData?.installments[3]?.price)
// setDetails([
//       { name: "مقدم الدفع", price: filterData?.details?.[0]?.price },
//     { name: "المبلغ الذي بدفع أول يوم دراسة", price: filterData?.details?.[1]?.price },
//     { name: "سبتمبر", price: filterData?.details?.[2]?.price },
//     { name: "أكتوبر", price: filterData?.details?.[3]?.price },
//     { name: "نوفمبر", price: filterData?.details?.[4]?.price },
//     { name: "ديسمبر", price: filterData?.details?.[5]?.price },
//     { name: "يناير", price: filterData?.details?.[6]?.price },
//     { name: "فبراير", price: filterData?.details?.[7]?.price },
//     { name: "مارس", price: filterData?.details?.[8]?.price },
//     { name: "أبريل", price: filterData?.details?.[9]?.price },
//     { name: "مايو", price: filterData?.details?.[10]?.price },
// ])
// // const option = res.data.data.data.map((item) => ({
// //   label: item?.name,
// //   value: item?.id
// // }));
//                 })
//                 .catch((error) => {


//                 });
// } catch (error) {
//   console.log(error);
  
// }

//       await axios
//         .get(`https://nanosoft.space/taarteb/public/api/grade-categories`, {
//           headers: {
//             Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
//           }
//         })
//         .then(async (res) => {
//           const options = res.data.data.data.map(item => ({
//             value: item.id,
//             label: item.name
//           }));
//           setGradeItems(options)


//         })
//         .catch((error) => {


//         });
//       if (grade_id.value) {
//         await axios
//           .get(`https://nanosoft.space/taarteb/public/api/grades`, {
//             headers: {
//               Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
//             }
//           })
//           .then(async (res) => {
//             const options = res.data.data.data.map(item => ({
//               value: item.id,
//               label: item.name
//             }));
//             setstageItems(options)


//           })
//           .catch((error) => {


//           });
//       }
//     }
//     getAllApis()

//   }, [grade_id.value])

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const formData =
//     {
//       "grade_category_id": grade_id.value,
//       "grade_id": stage_id.value,
//       "price": price,
//       details:details,
//       "installments": [
//         {
//           "name":"Tuitionfees",
//           "price":Tuitionfees
//         },
//                 {
//           "name":"Transportationfees",
//           "price":Transportationfees
//         },
//                 {
//           "name":"Mealfees",
//           "price":Mealfees
//         },
//                 {
//           "name":"Bookfees",
//           "price":Bookfees
//         },
//                 {
//           "name":"Studyexpenses",
//           "price":Studyexpenses
//         },
            
//       ]
//     }
//     try {



//       if (id) {
//         const response = await axios.post(
//           `https://nanosoft.space/taarteb/public/api/maintenances/${id}`,
//           formData,
//           {
//             headers: {
//               Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//             },
//           }
//         );

//         toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
//         navigate("/dashboard/expenses/all");

//       } else {
//         const response = await axios.post(
//           "https://nanosoft.space/taarteb/public/api/admin/expenses",
//           formData,
//           {
//             headers: {
//               Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//             },
//           }
//         );

//         toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
//         navigate("/dashboard/expenses/all");

//       }

//     } catch (error) {
//       console.error(error);
//       toast.error(
//         error.response?.data?.message || "Something went wrong",
//         { position: "bottom-right", autoClose: 3000 }
//       );
//     } finally {
//       setLoading(false);
//     }
//   };


//   return (
//     <div className='add_student_form_container'>
//       <ToastContainer />

//       <form className='form_container'>
//         <Container fluid>
//           <Row>
//             <Col md={6}>
//               <div>
//                 <label>{currentLocal.home.stageName}</label>
//                 <br />
//                 <div className='mb-3'>
//                   <Select
//                     value={grade_id}
//                     onChange={(selectedOption) => setGrade_id(selectedOption)}
//                     options={gradeItems}
//                     placeholder={currentLocal.home.stageName} // Change this text

//                   />
//                 </div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div>
//                 <label>{currentLocal.home.grade}</label>
//                 <br />
//                 <div className='mb-3'>
//                   <Select
//                     value={stage_id}
//                     onChange={(selectedOption) => setStages_id(selectedOption)}
//                     options={stagesItems}
//                     placeholder={currentLocal.home.grade} // Change this text

//                   />
//                 </div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div>
//                 <label>{currentLocal.home.price}</label>
//                 <CustomInput
//                   placeholder={currentLocal.home.price}
//                   value={price}
//                   onChange={(e) => setPrice(e.target.value)}
//                 />
//               </div>
//             </Col>



    //         <h5>تفاصيل المصاريف</h5>
    //         <Col md={6}>
    //           <label style={{ width: '150px' }}>رسوم الدراسة</label>
    //           <CustomInput
    //             placeholder="رسوم الدراسة"
    //             type="number"
    //             value={Tuitionfees}
    //             onChange={(e) => setTuitionfees(e.target.value)}
    //           />

    //         </Col>
    //         <Col md={6}>
    //           <label style={{ width: '150px' }}>رسوم نقل </label>
    //           <CustomInput
    //             placeholder="رسوم نقل "
    //             type="number"
    //             value={Transportationfees}
    //             onChange={(e) => setTransportationfees(e.target.value)}
    //           />

    //         </Col>
    //         <Col md={6}>
    //           <label style={{ width: '150px' }}>رسوم وجبه </label>
    //           <CustomInput
    //             placeholder="رسوم وجبه "
    //             type="number"
    //             value={Mealfees}
    //             onChange={(e) => setMealfees(e.target.value)}
    //           />

    //         </Col>
    //         <Col md={6}>
    //           <label style={{ width: '150px' }}>رسوم كتب </label>
    //           <CustomInput
    //             placeholder="رسوم كتب "
    //             type="number"
    //             value={Bookfees}
    //             onChange={(e) => setBookfees(e.target.value)}
    //           />

    //         </Col>
    //         <Col md={6}>
    //           <label style={{ width: '150px' }}>التزمات دراسية </label>
    //           <CustomInput
    //             placeholder="التزمات دراسية "
    //             type="number"
    //             value={Studyexpenses}
    //             onChange={(e) => setStudyexpenses(e.target.value)}
    //           />

    //         </Col>
            // {/* <Col md={6}>
            //   <label style={{ width: '150px' }}>رسوم نقل بعيد </label>
            //   <CustomInput
            //     placeholder="رسوم نقل بعيد "
            //     type="number"
            //     value={Distancetravelfees}
            //     onChange={(e) => setDistancetravelfees(e.target.value)}
            //   />

            // </Col> */}
    //         {/* {details.map((item, index) => (
    //           <Col md={6} key={index} className=" mb-2">
    //             <label style={{ width: '150px' }}>{item.name}</label>
    //             <CustomInput
    //               placeholder="السعر"
    //               type="number"
    //               value={item.price}
    //               onChange={(e) => {
    //                 const newDetails = [...details];
    //                 newDetails[index].price = e.target.value;
    //                 setDetails(newDetails);
    //               }}
    //             />
    //           </Col>
    //         ))} */}

    //         <h5 className='mt-4'>تفاصيل الدفع </h5>
    //         {details.map((item, index) => (
    //           <Col md={6} key={index} className=" mb-2">
    //             <label style={{ width: '250px' }}>{item.name=="مقدم الدفع"?item.name+" "+"المبلغ يدفع عند التسجيل":item.name}</label>
    //             <CustomInput
    //               placeholder="السعر"
    //               type="number"
    //               value={item.price}
    //               onChange={(e) => {
    //                 const newDetails = [...details];
    //                 newDetails[index].price = e.target.value;
    //                 setDetails(newDetails);
    //               }}
    //             />
    //           </Col>
    //         ))}
    //         <Col md={12}>
    //           <div className='d-flex justify-content-center mt-4 '>
    //             <div className='w-50 d-flex justify-content-center'>
    //               <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.add} disabled={loading} clickingFunction={handleSubmit} />

    //             </div>
    //           </div>
    //         </Col>
    //       </Row>


    //     </Container>
    //   </form>
    // </div>
//   )
// }


// export default AddAllExpensesForm


import './AddAllExpensesForm.css'
import CustomInput from "../CustomInput/CustomInput";
import CustomBtn from "../CustomBtn/CustomBtn";
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function AddAllExpensesForm() {
    const userinfo = useSelector((state) => state);
    const { currentLocal } = useSelector((state) => state.currentLocal);
    const navigate = useNavigate();
    const { id } = useParams();

    const [grade_id, setGrade_id] = useState(null);
    const [stage_id, setStages_id] = useState(null);
    const [price, setPrice] = useState('');
    const [gradeItems, setGradeItems] = useState([]);
    const [stagesItems, setstageItems] = useState([]);
    const [Tuitionfees, setTuitionfees] = useState('');
    const [Transportationfees, setTransportationfees] = useState('');
    const [Mealfees, setMealfees] = useState('');
    const [Bookfees, setBookfees] = useState('');
    const [Studyexpenses, setStudyexpenses] = useState('');
    const [loading, setLoading] = useState(false);
    
    const [details, setDetails] = useState([
        { name: "مقدم الدفع", price: 0 },
        { name: "المبلغ الذي بدفع أول يوم دراسة", price: 0 },
        { name: "سبتمبر", price: 0 },
        { name: "أكتوبر", price: 0 },
        { name: "نوفمبر", price: 0 },
        { name: "ديسمبر", price: 0 },
        { name: "يناير", price: 0 },
        { name: "فبراير", price: 0 },
        { name: "مارس", price: 0 },
        { name: "أبريل", price: 0 },
        { name: "مايو", price: 0 },
        { name: "يونيه", price: 0 },
        { name: "يوليه", price: 0 },
    ]);

    const headers = {
        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
    };

    // 1. INITIAL LOAD: Fetch categories and existing data if editing
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Fetch Categories
                const catRes = await axios.get(`https://nanosoft.space/taarteb/public/api/grade-categories`, { headers });
                const options = catRes.data.data.data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setGradeItems(options);

                // If ID exists, fetch the specific expense to edit
                if (id) {
                    const expRes = await axios.get(`https://nanosoft.space/taarteb/public/api/admin/expenses`, { headers });
                    const filterData = expRes.data.data.find((item) => item?.id == id);
                    
                    if (filterData) {
                        setGrade_id({ label: filterData?.grade_category?.name, value: filterData?.grade_category?.id });
                        setStages_id({ label: filterData?.grade?.name, value: filterData?.grade?.id });
                        setPrice(filterData?.price);
                        setTuitionfees(filterData?.installments[0]?.price || '');
                        setTransportationfees(filterData?.installments[1]?.price || '');
                        setMealfees(filterData?.installments[2]?.price || '');
                        setBookfees(filterData?.installments[4]?.price || '');
                        setStudyexpenses(filterData?.installments[3]?.price || '');
                        
                        if(filterData.details) {
                            const newDetails = details.map((d, index) => ({
                                ...d,
                                price: filterData.details[index]?.price || 0
                            }));
                            setDetails(newDetails);
                        }
                    }
                }
            } catch (error) {
                console.error("Error loading initial data", error);
            }
        };

        fetchInitialData();
    }, [id]); // Only runs on mount or if ID changes

    // 2. DEPENDENT LOAD: Fetch Grades when Category changes
    useEffect(() => {
        const fetchGrades = async () => {
            if (grade_id?.value) {
                try {
                    const res = await axios.get(`https://nanosoft.space/taarteb/public/api/students/grade-categories/${grade_id?.value}/grades`, { 
                        headers 
                    });
                    console.log(res.data.data);
                    
                    const options = res.data.data.map(item => ({
                        value: item.id,
                        label: item.name
                    }));
                    setstageItems(options);
                } catch (error) {
                    console.error("Error fetching grades", error);
                }
            }
        };
        fetchGrades();
    }, [grade_id?.value]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = {
            "grade_category_id": grade_id?.value,
            "grade_id": stage_id?.value,
            "price": price,
            details: details,
            "installments": [
                { "name": "Tuitionfees", "price": Tuitionfees,is_optional:0 },
                { "name": "Transportationfees", "price": Transportationfees,is_optional:0 },
                { "name": "Mealfees", "price": Mealfees ,is_optional:0},
                { "name": "Bookfees", "price": Bookfees ,is_optional:0},
                { "name": "Studyexpenses", "price": Studyexpenses,is_optional:0 },
            ]
        };

        try {
            const url = id 
                ? `https://nanosoft.space/taarteb/public/api/admin/expenses/${id}` 
                : "https://nanosoft.space/taarteb/public/api/admin/expenses";
            
            const response = await axios.post(url, formData, { headers });
            toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
            navigate("/dashboard/expenses/all");
        } catch (error) {
            toast.error(error.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='add_student_form_container'>
            <ToastContainer />
            <form className='form_container' onSubmit={handleSubmit}>
                <Container fluid>
                    <Row>
                        <Col md={6}>
                            <label>{currentLocal.home.stageName}</label>
                            <div className='mb-3'>
                                <Select
                                    value={grade_id}
                                    onChange={(selectedOption) => {
                                        setGrade_id(selectedOption);
                                        setStages_id(null); // Reset grade selection when category changes
                                    }}
                                    options={gradeItems}
                                    placeholder={currentLocal.home.stageName}
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <label>{currentLocal.home.grade}</label>
                            <div className='mb-3'>
                                <Select
                                    value={stage_id}
                                    onChange={(selectedOption) => setStages_id(selectedOption)}
                                    options={stagesItems}
                                    placeholder={currentLocal.home.grade}
                                />
                            </div>
                        </Col>
                        {/* Rest of your UI components remain the same... */}
                        <Col md={6}>
                            <label>{currentLocal.home.price}</label>
                            <CustomInput
                                placeholder={currentLocal.home.price}
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                            />
                        </Col>
                        {/* Ensure your CustomBtn is inside the form and use type="submit" or leave it as is if clickingFunction handles it */}
                        {/* <Col md={12}>
                            <div className='d-flex justify-content-center mt-4 '>
                                <div className='w-50 d-flex justify-content-center'>
                                    <CustomBtn 
                                        text={loading ? currentLocal.home.Loading : currentLocal.home.add} 
                                        disabled={loading} 
                                        clickingFunction={handleSubmit} 
                                    />
                                </div>
                            </div>
                        </Col> */}
            <h5>تفاصيل المصاريف</h5>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم الدراسة</label>
              <CustomInput
                placeholder="رسوم الدراسة"
                type="number"
                value={Tuitionfees}
                onChange={(e) => setTuitionfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم نقل </label>
              <CustomInput
                placeholder="رسوم نقل "
                type="number"
                value={Transportationfees}
                onChange={(e) => setTransportationfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم وجبه </label>
              <CustomInput
                placeholder="رسوم وجبه "
                type="number"
                value={Mealfees}
                onChange={(e) => setMealfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم كتب </label>
              <CustomInput
                placeholder="رسوم كتب "
                type="number"
                value={Bookfees}
                onChange={(e) => setBookfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>التزمات دراسية </label>
              <CustomInput
                placeholder="التزمات دراسية "
                type="number"
                value={Studyexpenses}
                onChange={(e) => setStudyexpenses(e.target.value)}
              />

            </Col>
            {/* <Col md={6}>
              <label style={{ width: '150px' }}>رسوم نقل بعيد </label>
              <CustomInput
                placeholder="رسوم نقل بعيد "
                type="number"
                value={Distancetravelfees}
                onChange={(e) => setDistancetravelfees(e.target.value)}
              />

            </Col> */}
            {/* {details.map((item, index) => (
              <Col md={6} key={index} className=" mb-2">
                <label style={{ width: '150px' }}>{item.name}</label>
                <CustomInput
                  placeholder="السعر"
                  type="number"
                  value={item.price}
                  onChange={(e) => {
                    const newDetails = [...details];
                    newDetails[index].price = e.target.value;
                    setDetails(newDetails);
                  }}
                />
              </Col>
            ))} */}

            <h5 className='mt-4'>تفاصيل الدفع </h5>
            {details.map((item, index) => (
              <Col md={6} key={index} className=" mb-2">
                <label style={{ width: '250px' }}>{item.name=="مقدم الدفع"?item.name+" "+"المبلغ يدفع عند التسجيل":item.name}</label>
                <CustomInput
                  placeholder="السعر"
                  type="number"
                  value={item.price}
                  onChange={(e) => {
                    const newDetails = [...details];
                    newDetails[index].price = e.target.value;
                    setDetails(newDetails);
                  }}
                />
              </Col>
            ))}
            <Col md={12}>
              <div className='d-flex justify-content-center mt-4 '>
                <div className='w-50 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : id?currentLocal.home.edit:currentLocal.home.add} disabled={loading} clickingFunction={handleSubmit} />

                </div>
              </div>
            </Col>
          </Row>


        </Container>
      </form>
    </div>

    );
}

export default AddAllExpensesForm;